define('common/payment/piqConstants',{
    // PIQ specific types that our backend maps to basic types (provider & psp service delimited by '/')
    CREDITCARD: 'creditcard',
    NETELLER: 'neteller',
    SKRILL: 'skrill',
    BANK: 'bank',
    BANK_LOCAL: 'banklocal',
    BANK_IBAN: 'bankiban',
    BANK_IBAN_INTERNATIONAL: 'bankintiban',
    PUGGLEPAY: 'pugglepay',
    PAYSAFECARD: 'paysafecard',
    BOKU: 'boku',
    ENVOY_IDEAL: 'envoy/ideal',
    ENVOY_SOFORT: 'envoy/sofort',
    ENVOY_BANKTRANSFER: 'envoy/banktransfer',
    ENVOY_PAYSAFECARD: 'envoy/paysafecard',
    ENVOY_GIROPAY: 'envoy/giropay',

    DEPOSIT: 'deposit',
    QUICK_DEPOSIT: 'quick-deposit',
    WITHDRAWAL: 'withdrawal',

    channel: {
        MOBILE: 'mobile',
        DESKTOP: 'desktop',
        EPRO_DESKTOP: 'epro-desktop'
    },

    // Casumo specific types (values correspond to PaymentMethodType keys & cms slugs)
    types: {
        CREDITCARD: 'CREDITCARD',
        VISA_CARD: 'VISA_CARD',
        MASTER_CARD: 'MASTER_CARD',
        NETELLER: 'NETELLER',
        SKRILL: 'MONEYBOOKERS',
        TRUSTLY: 'TRUSTLY', /* Not used but needed for transaction history */
        BANK_DEPOSIT: 'BANK_DEPOSIT',
        BANK_WITHDRAW: 'BANK_WITHDRAW',
        PUGGLEPAY: 'PUGGLEPAY',
        PAYSAFECARD: 'PAYSAFECARD',
        EPRO: 'EPRO',
        IDEAL: 'IDEAL',
        SOFORT: 'SOFORT',
        GIROPAY: 'GIROPAY',
        BOKU: 'BOKU'
    },

    detail: {
        PROVIDER: 'PAYMENTIQ_PROVIDER',
        PAYMENTIQ_TX_ID: 'PAYMENTIQ_TX_ID',
        WITHDRAW_REJECTED_TIMESTAMP: 'WITHDRAW_REJECTED_TIMESTAMP'
    },

    reason: {
        WITHDRAW: 'WITHDRAW',
        DEPOSIT: 'DEPOSIT',
        REJECTED_WITHDRAW_PSP: 'REJECTED_WITHDRAW_PSP',
        REJECTED_WITHDRAW_MANUALLY_BY_PLAYER: 'REJECTED_WITHDRAW_MANUALLY_BY_PLAYER',
        REJECTED_WITHDRAW_MANUALLY_BY_OPERATOR: 'REJECTED_WITHDRAW_MANUALLY_BY_OPERATOR'
    },

    state: {
        DONE: 'DONE',
        REJECTED: 'REJECTED',
        PENDING: 'PENDING'
    }
});

